import { render, staticRenderFns } from "./DemoAccountDetails.vue?vue&type=template&id=4c0de24a"
import script from "./DemoAccountDetails.vue?vue&type=script&lang=js"
export * from "./DemoAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports